import { createRouter, createMemoryHistory } from "vue-router";
import MainView from "./views/shared/MainView.vue";

const routes = [
  {
    path: "/",
    component: MainView,
  },
];

export const router = createRouter({
  routes,
  history: createMemoryHistory(),
});
